<template>
	<main class="sell">
		<div class="sell__inner _cnt">
			<div class="sell__top">
				<div class="sell__title _h1">
					{{ $t('Sell your skin') }}
				</div>
				<div class="sell__line _line"><span></span></div>
			</div>
			<div v-if="isLoading" class="sell__loading _l">
				{{ $t('Loading') }}...
			</div>
			<div v-else-if="!items.length" class="sell__empty _l">
				{{ $t('No orders found') }}
			</div>
			<div class="sell__body">
				<div class="sell__box">
					<div class="sell__nav">
						<div class="sell__nav-item sell__nav-item_1">
							{{ $t('ID') }}
						</div>
						<div class="sell__nav-item sell__nav-item_2">
							{{ $t('Date') }}
						</div>
						<div class="sell__nav-item sell__nav-item_3">
							{{ $t('Item') }}
						</div>
						<div class="sell__nav-item sell__nav-item_4">
							{{ $t('Quantity') }}
						</div>
						<div class="sell__nav-item sell__nav-item_5">
							<span v-if="!hasServicePrice">{{ $t('Amount') }}</span>
							<span v-else>{{ $t('Your Price') }}</span>
						</div>
						<div
							v-if="hasServicePrice"
							class="sell__nav-item sell__nav-item_6"
						>
							{{ $t('Our Price') }}
						</div>
						<div class="sell__nav-item sell__nav-item_7">
							{{ $t('Status') }}
						</div>
						<div class="sell__nav-item sell__nav-item_8">
							{{ $t('Action') }}
						</div>
					</div>
					<div class="sell__items">
						<div
							class="sell__item"
							v-for="(item, index) in paginatedItems"
							:key="`${item.id}-${index}`"
						>
							<div class="sell__id">{{ item.id }}</div>
							<div class="sell__date">
								{{ formatDate(item.created_at) }}
							</div>
							<div class="sell__about">
								<div class="sell__name">
									{{ item.title }}
								</div>
							</div>
							<div class="sell__quantity">
								{{ item.quantity }}
							</div>
							<div class="sell__price-wrapper">
								<div class="sell__price">
									<div class="sell__price-number">
										{{ formatPrice(item.user_price) }}
									</div>
									<div class="sell__price-sumbol">
										{{ item.currency }}
									</div>
								</div>
								<div>/</div>
								<div
								v-if="item.user_internal_price || item.internal_price"
								class="sell__price sell__price-coin"
							>
									<div class="sell__price-number">
										{{ formatPrice(item.user_internal_price ?? item.internal_price) }}
									</div>
									<div class="sell__price-icon _svg-icon">
										<img src="@/assets/images/coin.svg" alt="coin" width="100%" height="100%" />
									</div>
								</div>
							</div>
							<div v-if="hasServicePrice" class="sell__service-price-wrapper">
								<div v-if="item.service_price" class="sell__service-price">
									<div class="sell__service-price-number">
										{{ formatPrice(item.service_price) }}
									</div>
									<div class="sell__service-price-sumbol">
										{{ item.currency }}
									</div>
								</div>
								<div
								v-if="item.service_price && hasInternalValue(item)"
							>
								/
							</div>
							<div
								v-if="item.service_price && hasInternalValue(item)"
								class="sell__service-price sell__service-price-coin"
							>
									<div class="sell__service-price-number">
										{{ formatPrice(getServiceInternal(item)) }}
									</div>
									<div class="sell__service-price-icon _svg-icon">
										<img src="@/assets/images/coin.svg" alt="coin" width="100%" height="100%" />
									</div>
								</div>
							</div>
							<div class="sell__status">
								<span
									v-if="item.status"
									:class="['sell__status-label', getStatusClass(item.status)]"
								>
									<span>{{ item.status_display }}</span>
								</span>
							</div>
							<button
								v-if="item.status !== 'ready_for_payout'"
								class="sell__action _btn-bordered"
								@click="openPreviewSkinModal(item)"
							>
								{{ $t('view offer') }}
							</button>

							<button
								v-if="
									item.status === 'ready_for_payout' &&
									item.service_price
								"
								class="sell__action _btn-primary"
								@click="openPreviewSkinModal(item)"
							>
								{{ $t('Pay') }}
							</button>
						</div>
					</div>
				</div>
				<PaginationComponent
					class="sell__pagination"
					v-if="totalProducts > 0 && !isLoading"
					:total-pages="totalPages"
					:per-page="itemsPerPage"
					:current-page="currentPage"
					@update:per-page="updatePerPage"
					@update:current-page="changePage"
				/>
				<button @click="sellSkin" class="sell__new _btn-primary">
					{{ $t('create new offer') }}
				</button>
			</div>
		</div>
		<Transition>
			<ViewOfferModal
				v-if="previewSkinModalIsVisible"
				:refresh-offer-history="refreshOfferHistory"
				:item="selectedItem"
				:user="user"
				@closePreviewSkinModal="closePreviewSkinModal"
			/>
		</Transition>
	</main>
</template>

<script>
import PaginationComponent from '@/components/PaginationComponent.vue';
import ViewOfferModal from '@/components/ViewOfferModal.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'SellSkin',
	components: {
		PaginationComponent,
		ViewOfferModal,
		//DepositModal,
	},
	props: {
		offerHistory: {
			type: Array,
			default: () => [],
		},
		isAuth: {
			type: Boolean,
			default: false,
		},
		previewSkinModalIsVisible: {
			type: Boolean,
			default: false,
		},
		refreshOfferHistory: {
			type: Function,
		},
		paymentMethods: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			selectedAmount: null,
			isLoading: false,
			currentPage: 1,
			itemsPerPage: 5,
			isOfferModalOpen: false,
			selectedItem: null,
			user: {
				email: '',
				name: '',
				surname: '',
				phone: '',
				phoneCountryCode: null,
				address: '',
				country: '',
				city: '',
				zip: '',
				balance: 0,
				steamId: '',
				steamProfileUrl: null,
				avatarMedium: '',
				status: '',
			},
		};
	},
	computed: {
		...mapGetters('app', ['currencySymbol', 'currencyValue', 'currencyCode']),
		...mapGetters('user', ['userBalance']),
		...mapGetters('modals', ['depositModalIsVisible']),
		hasServicePrice() {
			// true if at least one offer has service_price
			return (
				Array.isArray(this.offerHistory) &&
				this.offerHistory.some(
					(o) =>
						o && o.service_price !== null && o.service_price !== undefined
				)
			);
		},

		items() {
			if (!this.offerHistory || !this.offerHistory.length) return [];

			return this.offerHistory.map((offer) => ({
				id: offer.id,
				// backend gives `date_time` in seconds; convert to ms
				created_at: (offer.date_time ?? offer.created_at) * 1000,
				title: offer.title || 'Unknown Item',
				quantity: 1, // no count in offer history → 1
				user_price: offer.user_price,
				service_price: offer.service_price,
				currency: offer.currency || 'EUR',
				status: offer.status,
				status_display: offer.status_display,
				img_url: offer.item_url || '',
				item_quality: offer.quality || '',
				item_type: offer.type || '',
				internal_price: offer.internal_price,
				user_internal_price: offer.user_internal_price,
				user_fiat_price: offer.user_fiat_price,
				service_internal_price: offer.service_internal_price,
				service_fiat_price: offer.service_fiat_price,
				fiat_currency: offer.fiat_currency,
			}));
		},

		sortedItems() {
			return [...this.items].sort((a, b) => b.created_at - a.created_at);
		},

		totalPages() {
			return Math.ceil(this.sortedItems.length / this.itemsPerPage) || 1;
		},

		paginatedItems() {
			const start = (this.currentPage - 1) * this.itemsPerPage;
			const end = start + this.itemsPerPage;
			return this.sortedItems.slice(start, end);
		},

		totalProducts() {
			return this.sortedItems.length;
		},
	},
	mounted() {
		this.fetchUserData();
		console.log('offerHistory in SellSkin', this.offerHistory);
	},
	methods: {
		...mapActions('modals', ['openDepositModal']),
		formatPrice(value) {
			if (value === null || value === undefined || value === '') return '0.00';
			const numberValue = Number(value);
			if (Number.isNaN(numberValue)) return '0.00';
			return numberValue.toFixed(2);
		},
		hasInternalValue(item) {
			return Boolean(
				item?.service_internal_price ??
				item?.user_internal_price ??
				item?.internal_price
			);
		},
		getServiceInternal(item) {
			return (
				item?.service_internal_price ??
				item?.user_internal_price ??
				item?.internal_price ??
				0
			);
		},
		redirectToDepositModal(item) {
			this.selectedAmount = item.service_price;
			console.log('item.service_price', item.service_price);
			console.log('selectedAmount', this.selectedAmount);
			this.openDepositModal();
		},
		async fetchUserData() {
			try {
				const response = await this.$http.get(
					'user/profile'
				);
				if (response.status === 200 && response.data) {
					this.user.name = response.data.name;
					this.user.surname = response.data.surname;
					this.user.email = response.data.email;
					this.user.phone = response.data.phone;
					this.user.country = response.data.country;
					this.user.city = response.data.city;
					this.user.zip = response.data.zip;
					this.user.address = response.data.address;
					this.user.balance = response.data.balance;
					this.user.steamId = response.data.steamId;
					this.user.steamProfileUrl = response.data.steam_profile_url;
					this.user.avatarMedium = response.data.avatar_medium;
					this.user.status = response.data.status;
				}
			} catch (error) {
				console.log('errro');

				//  this.$router.push({ path: "/" });
				console.error('Error fetching user data:', error);
			}
		},

		getStatusClass(status) {
			const s = (status || '').toString().toLowerCase();

			switch (s) {
				case 'completed':
				case 'accepted':
				case 'approved':
				case 'ready_for_payout':
					return 'sell__status-success';

				case 'processing':
				case 'in_process':
				case 'pending':
				case 'payout_processing':
				case 'awaiting_item':
				case 'offer':
					return 'sell__status-pending';
				case 'canceled':
				case 'cancelled':
				case 'declined':
				case 'declined_by_user':
				case 'declined_by_service':
					return 'sell__status-error';

				default:
					return '';
			}
		},

		openPreviewSkinModal(item) {
			this.selectedItem = item;
			this.$emit('openPreviewSkinModal');
		},
		closePreviewSkinModal() {
			this.selectedItem = null;
			this.$emit('closePreviewSkinModal');
		},
		//getItemImageUrl(imgUrl) {
		//	if (!imgUrl) return '';
		//	const imgDomain = process.env.VUE_APP_API || '';
		//	if (imgUrl.startsWith('http')) return imgUrl;
		//	return `${imgDomain}${imgUrl}`;
		//},
		formatDate(timestamp) {
			if (!timestamp) return '';

			const date = new Date(timestamp);

			const day = String(date.getDate()).padStart(2, '0');
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const year = date.getFullYear();

			return `${day}.${month}.${year}`;
		},
		sellSkin() {
			if (this.isAuth) {
				this.$emit('openSellSkinModal');
			} else {
				this.$emit('openSignIn');
			}
		},
		updatePerPage(newPerPage) {
			this.itemsPerPage = Number(newPerPage) || 5;
			this.currentPage = 1; // reset to first page when per-page changes
		},

		changePage(newPage) {
			// basic safety so we don’t go out of range
			const page = Number(newPage) || 1;
			if (page < 1) {
				this.currentPage = 1;
			} else if (page > this.totalPages) {
				this.currentPage = this.totalPages;
			} else {
				this.currentPage = page;
			}
		},
	},
};
</script>

<style scoped lang="scss">
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

.sell {
	@include header-indent;
	@include adaptiveValue('padding-top', 50, 25);
	@include adaptiveValue('padding-bottom', 50, 20);
	&__inner {
	}
	&__top {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 37, 20);
		}
	}
	&__title {
		text-align: center;
		display: block;
		margin: 0 auto;
	}
	&__line {
		max-width: 710px;
		margin-left: auto;
		margin-right: auto;
	}
	&__loading {
		text-align: center;
	}
	&__empty {
		text-align: center;
	}

	&__body {
		//min-width: fit-content;
	}
	&__box {
		overflow-x: auto;
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 37, 20);
		}
	}
	&__nav {
		@include adaptiveValue('padding', 15, 10, 1470, 768, 1);
		display: flex;
		min-width: 100%;
		align-items: center;
		background-color: var(--bg-fourth-color);
		min-height: 54px;
		border-radius: var(--border-radius-primary);
		width: fit-content;
		gap: 20px;
		font-weight: 900;
		text-transform: uppercase;
		&-item {
			&_1 {
				flex: 0 0 150px;
				min-width: 150px;
			}
			&_2 {
				flex: 0 0 150px;
				min-width: 150px;
			}
			&_3 {
				flex: 1 1 auto;
				min-width: 200px;
			}
			&_4 {
				flex: 0 0 90px;
			}
			&_5,
			&_6 {
				flex: 0 0 180px;
			}
			&_7 {
				flex: 0 0 160px;
			}
			&_8 {
				flex: 0 0 140px;
			}
		}
	}
	&__items {
		width: fit-content;
		min-width: 100%;
	}
	&__item {
		display: flex;
		column-gap: 20px;
		align-items: center;
		@include adaptiveValue('padding', 15, 10, 1470, 768, 1);
		border-bottom: 1px solid var(--bg-third-color);
	}
	&__id {
		flex: 0 0 150px;
		min-width: 150px;
	}
	&__date {
		flex: 0 0 150px;
		min-width: 150px;
	}
	&__about {
		display: flex;
		gap: 10px;
		flex: 1 1 auto;
		min-width: 200px;
	}
	&__name {
		align-self: center;
		font-weight: 400;
	}
	&__quantity {
		display: flex;
		justify-content: center;
		flex: 0 0 90px;
		align-self: center;
	}
	&__service-price,
	&__price {
		display: flex;
		align-items: center;
		gap: 4px;
		font-weight: 400;
		&-wrapper {
			display: flex;
			flex-wrap: wrap;
			gap: 4px;
			flex: 0 0 180px;
		}
		&-label {
			@include hide-item;
		}
		&-number {
		}
		&-sumbol {
		}
		&-coin {
			.sell__service-price-number {
				font-weight: 900;
			}
			.sell__service-price-icon {
				flex: 0 0 16px;
				height: 16px;
			}
			.sell__price-number {
				font-weight: 900;
			}
			.sell__price-icon {
				flex: 0 0 16px;
				height: 16px;
			}
		}
		&-icon {
		}
	}
	&__status {
		text-transform: capitalize;
		flex: 0 0 160px;
		&-success {
			color: var(--success-color);
		}
		&-pending {
			color: var(--pending-color);
		}
		&-error {
			color: var(--error-color);
		}
	}
	&__action {
		flex: 0 0 140px;
	}
	&__pagination {
		&:not(:last-child) {
			@include adaptiveValue('margin-bottom', 37, 20);
		}
	}
	&__new {
		width: 100%;
		max-width: 350px;
		margin: 0 auto;
	}
}
</style>
